import { useSearchParams } from 'react-router-dom';

export function useRouterApplicationId() {
  const [searchParams] = useSearchParams();
  const applicationId = searchParams.get('applicationId');

  if (typeof applicationId === 'string') {
    return applicationId;
  }
}
